import { UserB } from "app/pages/ok-admin/user-b/user-b"

export class Comment {
    id: string

    userId: string

    userName: string

    publishDate : string

    userType: string

    fileUrl: string

    idRequest: string

    description: string

    userB : UserB

    idDocumentFile : string
}